<template>
  <v-card outlined>
    <v-card-title>
      Настройки платежного агента
    </v-card-title>
    <v-card-text>
      <v-form v-model="form_valid">
        <v-container fluid>
          <v-row dense>
            <v-col>
              <TextField label="Платежный агент" v-model="payment_agent.pay_agent" readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <TextField label="Сектор" type="number" :min="0" v-model="payment_agent.sector"
                :rules="[rules.numberRule]"
              />
            </v-col>
            <v-col>
              <TextField label="Подпись" v-model="payment_agent.key"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-switch label="Тестовый режим" v-model="payment_agent.is_test"></v-switch>
            </v-col>
            <v-col>
              <TextField label="Валюта" type="number" :min="0" v-model="payment_agent.currency"
                :rules="[rules.numberRule]"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <TextField label="Время ожидания оплаты (минуты)" type="number" :min="0" v-model="payment_agent.time_pay"
              />
            </v-col>
            <v-col>
              <TextField
                label="Система налогообложения"
                :value="taxationSystemName"
                readonly
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <TextField label="Описание заказа" v-model="payment_agent.pay_description"
              />
            </v-col>
            <v-col>
              <TextField
                label="Ставка НДС"
                :value="ndsName"
                readonly
              />
            </v-col>
          </v-row>
          
          <!-- <v-row dense>
            <v-col cols="12">
              <TextField label="URL" v-model="payment_agent.url"/>
            </v-col>
            <v-col cols="12">
              <TextField label="Fail URL" v-model="payment_agent.fail_url"/>
            </v-col>
          </v-row> -->
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import TextField from '../../ui/TextField.vue';
import rules_mixin from '@/mixins/rules_mixin.js'

export default{

  props: {
    value: Object,
    original_value: Object,
  },
  
  data: () => ({
    form_valid: true,
    ndsSystems: [
        { 'code': 0, 'name': 'Общая, ОСН' },
        { 'code': 1, 'name': 'Упрощенная доход, УСН доход' },
        { 'code': 2, 'name': 'Упрощенная доход минус расход, УСН доход - расход' },
        { 'code': 3, 'name': 'Единый налог на вмененный доход, ЕНВД' },
        { 'code': 4, 'name': 'Единый сельскохозяйственный налог, ЕСН' },
        { 'code': 5, 'name': 'Патентная система налогообложения, Патент' },
    ],
    ndsRates: [
      { code: 1, name: 'Cтавка НДС 20%' },
      { code: 2, name: 'Cтавка НДС 10%' },
      { code: 3, name: 'Cтавка НДС расч. 20/120' },
      { code: 4, name: 'Cтавка НДС расч. 10/110' },
      { code: 5, name: 'Cтавка НДС 0%' },
      { code: 6, name: 'НДС не облагается' },
      { code: 7, name: 'Cтавка НДС 5%' },
      { code: 8, name: 'Cтавка НДС 7%' },
      { code: 9, name: 'Cтавка НДС расч. 5/105' },
      { code: 10, name: 'Cтавка НДС расч. 7/107' }
    ]
  }),

  mixins: [rules_mixin],

  computed:{
    taxationSystemName() {
      const item = this.ndsSystems.find(
        i => i.code === this.payment_agent.taxation_system
      )
      return item ? item.name : ''
    },
    ndsName() {
      const item = this.ndsRates.find(i => i.code === this.payment_agent.nds)
      return item ? item.name : ''
    },
    payment_agent:{
      set(v){
        this.$emit('input', v)
      },
      get(){
        return this.value
      }
    }
  },

  components:{
    TextField
  }
}
</script>